import React, { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBoxOpen,
    faCalendarAlt,
    faInfoCircle,
    faSearch
} from '@fortawesome/free-solid-svg-icons';
import 'chart.js/auto';
import { Line } from 'react-chartjs-2';
import styles from './StatisticsPage.module.scss';

const metricCards = [
    {
        title: 'No. of Total Input',
        value: '1,857,130',
    },
    {
        title: 'No. of Output',
        value: '754,965',
    },
    {
        title: 'SLA(%)',
        value: '54.97',
    },
    {
        title: 'Avg. Handling Time(s)',
        value: '27.16',
    },
];

const chartLabels = Array.from({ length: 31 }, (_, index) => `Aug ${index + 1}`);
const chartDataset = [
    120, 150, 180, 200, 170, 190, 210, 230, 250, 220,
    240, 260, 300, 280, 310, 330, 350, 320, 340, 360,
    370, 390, 400, 420, 410, 430, 440, 460, 470, 480, 500
];

const moderationBoardData = [
    {
        moderator: 'Moderator 1 username',
        assignedTasks: 70,
        completedTasks: '109.81',
        aht: '72.16%',
        sla: '-',
    },
    {
        moderator: 'Moderator 2 username',
        assignedTasks: 45,
        completedTasks: '89.79',
        aht: '97.57%',
        sla: '-',
    },
    {
        moderator: 'Moderator 3 username',
        assignedTasks: 35,
        completedTasks: '177.01',
        aht: '69.62%',
        sla: '-',
    },
    {
        moderator: 'Moderator 4 username',
        assignedTasks: 35,
        completedTasks: '48.74',
        aht: '58.24%',
        sla: '-',
    },
];

const queueStatisticsData = [
    {
        queue: 'Image',
        assignedTasks: 70,
        completedTasks: '109.81',
        aht: '72.16%',
        sla: '-',
    },
    {
        queue: 'Video',
        assignedTasks: 45,
        completedTasks: '89.79',
        aht: '97.57%',
        sla: '-',
    },
];

export const StatisticsPage = () => {
    const chartData = useMemo(() => ({
        labels: chartLabels,
        datasets: [
            {
                label: 'Total Input',
                data: chartDataset,
                borderColor: 'rgba(59, 130, 246, 1)',
                backgroundColor: 'rgba(59, 130, 246, 0.2)',
                fill: true,
                tension: 0.3,
                pointRadius: 3,
                pointBackgroundColor: 'rgba(37, 99, 235, 1)',
                pointBorderWidth: 0,
            },
        ],
    }), []);

    const chartOptions = useMemo(() => ({
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    label: (context) => ` ${context.raw.toLocaleString()} tasks`,
                },
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Day',
                    font: {
                        size: 14,
                        weight: '600',
                    },
                    color: '#374151',
                },
                ticks: {
                    color: '#6b7280',
                },
                grid: {
                    color: 'rgba(229, 231, 235, 0.6)',
                },
            },
            y: {
                beginAtZero: true,
                title: {
                    display: true,
                    text: 'Number of Tasks',
                    font: {
                        size: 14,
                        weight: '600',
                    },
                    color: '#374151',
                },
                ticks: {
                    color: '#6b7280',
                    callback: (value) => value.toLocaleString(),
                },
                grid: {
                    color: 'rgba(229, 231, 235, 0.6)',
                },
            },
        },
    }), []);

    return (
        <div className={styles['statistics-page']}>
            <header className={styles['page-header']}>
                <h2>Core Data</h2>
                <button type="button" className={styles['action-button']}>
                    <FontAwesomeIcon icon={faBoxOpen} />
                    <span>Export data</span>
                </button>
            </header>

            <section className={styles['metrics-grid']}>
                {metricCards.map((metric) => (
                    <article key={metric.title} className={styles['metric-card']}>
                        <div className={styles['metric-header']}>
                            <span>{metric.title}</span>
                            <FontAwesomeIcon icon={faInfoCircle} />
                        </div>
                        <div className={styles['metric-value']}>{metric.value}</div>
                    </article>
                ))}
            </section>

            <section className={styles['chart-card']}>
                <div className={styles['chart-header']}>
                    <span>No. of Total Input</span>
                </div>
                <div className={styles['chart-controls']}>
                    <label className={styles['radio-option']}>
                        <input type="radio" name="moderationTasks" defaultChecked />
                        <span>All</span>
                    </label>
                    <label className={styles['radio-option']}>
                        <input type="radio" name="moderationTasks" />
                        <span>Queue</span>
                    </label>
                    <div className={styles['input-control']}>
                        <FontAwesomeIcon icon={faCalendarAlt} />
                        <input type="text" placeholder="Select date range" />
                    </div>
                </div>
                <div className={styles['chart-container']}>
                    <Line data={chartData} options={chartOptions} />
                </div>
            </section>

            <section className={styles['table-section']}>
                <header className={styles['section-header']}>
                    <h3>
                        Moderation Board
                        <FontAwesomeIcon icon={faInfoCircle} />
                    </h3>
                    <button type="button" className={styles['action-button']}>
                        <FontAwesomeIcon icon={faBoxOpen} />
                        <span>Export data</span>
                    </button>
                </header>
                <div className={styles['table-filters']}>
                    <div className={styles['input-control']}>
                        <FontAwesomeIcon icon={faSearch} />
                        <input type="text" placeholder="Search moderator" />
                    </div>
                    <div className={styles['input-control']}>
                        <FontAwesomeIcon icon={faCalendarAlt} />
                        <input type="text" placeholder="Select date range" />
                    </div>
                </div>
                <div className={styles['table-wrapper']}>
                    <table className={styles['data-table']}>
                        <thead>
                            <tr>
                                <th>Moderator</th>
                                <th>Assigned Tasks</th>
                                <th>Completed Tasks</th>
                                <th>AHT (s)</th>
                                <th>SLA %</th>
                            </tr>
                        </thead>
                        <tbody>
                            {moderationBoardData.map((row) => (
                                <tr key={row.moderator}>
                                    <td className={styles['label-cell']}>{row.moderator}</td>
                                    <td className={styles['numeric-cell']}>{row.assignedTasks}</td>
                                    <td className={styles['numeric-cell']}>{row.completedTasks}</td>
                                    <td className={styles['numeric-cell']}>{row.aht}</td>
                                    <td className={styles['numeric-cell']}>{row.sla}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </section>

            <section className={styles['table-section']}>
                <header className={styles['section-header']}>
                    <h3>
                        Queue Statistics
                        <FontAwesomeIcon icon={faInfoCircle} />
                    </h3>
                    <button type="button" className={styles['action-button']}>
                        <FontAwesomeIcon icon={faBoxOpen} />
                        <span>Export data</span>
                    </button>
                </header>
                <div className={styles['table-filters']}>
                    <div className={styles['input-control']}>
                        <FontAwesomeIcon icon={faSearch} />
                        <input type="text" placeholder="Search queue name" />
                    </div>
                    <div className={styles['input-control']}>
                        <FontAwesomeIcon icon={faCalendarAlt} />
                        <input type="text" placeholder="Select date range" />
                    </div>
                </div>
                <div className={styles['table-wrapper']}>
                    <table className={styles['data-table']}>
                        <thead>
                            <tr>
                                <th>Queue</th>
                                <th>Assigned Tasks</th>
                                <th>Completed Tasks</th>
                                <th>AHT (s)</th>
                                <th>SLA %</th>
                            </tr>
                        </thead>
                        <tbody>
                            {queueStatisticsData.map((row) => (
                                <tr key={row.queue}>
                                    <td className={styles['label-cell']}>{row.queue}</td>
                                    <td className={styles['numeric-cell']}>{row.assignedTasks}</td>
                                    <td className={styles['numeric-cell']}>{row.completedTasks}</td>
                                    <td className={styles['numeric-cell']}>{row.aht}</td>
                                    <td className={styles['numeric-cell']}>{row.sla}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    );
};

export default StatisticsPage;

